import { useQuery } from '@tanstack/react-query';

import { queryFn } from './queryFn';

const QUERY_KEY = ['TRENDING_STOCKS'] as const;

export function useTrendingStocks({
  gridViewId,
  limit = 3,
  offset = 0,
}: {
  gridViewId: number;
  limit?: number;
  offset?: number;
}) {
  return useQuery({
    queryKey: [QUERY_KEY, gridViewId, limit, offset],
    queryFn: () => queryFn({ gridViewId, limit, offset }),
    retry: 1,
    staleTime: 3600000,
  });
}
